import React from "react";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import { useHistory, useLocation } from "react-router-dom";
import { BASE_PATH } from "../../../constants/awsBaseUrl";

const PurchasedContentCard = ({ video }) => {
  const { _id, metadata } = video;
  const history = useHistory();
  const location = useLocation();

  // redirect user to the video when card is clicked
  const goToVideo = () => {
    const companyEndpoint = location.pathname.split("/")[1];
    const redirectEndpoint = `/${companyEndpoint}/video/${_id}`;
    history.push(redirectEndpoint);
  };

  return (
    <Card>
      <CardActionArea onClick={goToVideo}>
        <CardMedia
          component="img"
          src={`${BASE_PATH}/outputs/${_id}/Default/Thumbnails/out_003.png?refresh=11132022`}
        />
        <CardContent>
          <Typography noWrap align="left" gutterBottom variant="subtitle2">
            <strong>{metadata?.filename}</strong>
          </Typography>

          <Typography
            noWrap
            paragraph
            variant="body2"
            color="textSecondary"
            component="p"
          >
            Description: {metadata?.description}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default PurchasedContentCard;
